import React, { useState, useEffect } from "react";
import { Row, Col, Form, Card, Button, Input } from "antd";
import { PersonalInformation } from "../../Auth/Profile/PersonalInformation";
import { PersonalInformationFEMA } from "../../Auth/Profile/PersonalInformationFEMA";
import { DocumentUpload } from "../../Auth/Profile/DocumentUpload";
import { useSelector } from "react-redux";
import moment from "moment";
import "../../../custom/scrollspy.css";
import { useLocation, useHistory } from "react-router-dom";
import JobInfo from "./_JobInfo";
import ScrollSpy from "./_ScrollSpy";
import { GlobalApiErrorHandler, string_trim } from "../../../shared/helpers";
import { CustomAlertModal } from "../../../shared";
import { BrowserView, MsgBox } from "../../../shared/custom-ant-d";
import {
  reqPostRetrieveCandidateApplication,
  reqGetJobUrl,
  reqGetRetrieveJobDetails,
  reqGetAppProperties,
  reqGetRetrieveApplicationLookupData,
  reqPostSaveApplication,
} from "../../../axios/api";

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export const ApplyPage = (props) => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [formRef] = Form.useForm();
  const { Auth, LookUpData, AppliedJobs } = useSelector((state) => state);
  const history = useHistory();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();

  const [jobDetails, setJobDetails] = useState(null);
  const [jobDetailsAfterFetch, setJobDetailsAfterFetch] = useState(null);
  const [displayTextList, setDisplayTextList] = useState(null);
  const [countries, setCountries] = useState(null);
  const [phoneMinChar, setPhoneMinChar] = useState(10);
  const [statesOfCountry, setStateOfCountry] = useState(null);
  const [selectedCountryName, setSelectedCountryName] = useState(
    Auth.countryName
  );
  const [preferredContactMethodList, setPreferredContactMethodList] =
    useState(null);
  const [statesList, setStatesList] = useState(null);
  const [disabilityStatusList, setDisabilityStatusList] = useState(null);
  const [ethnicityList, setEthnicityList] = useState(null);
  const [raceList, setRaceList] = useState(null);
  const [genderList, setGenderList] = useState(null);
  const [veteranList, setVeteranList] = useState(null);
  const [zipRequirments, setZipRequirements] = useState("");
  const [levelOfEduc, setLevelOfEduc] = useState(null);
  const [jobCountry, setJobCountry] = useState(null);
  const [showAfterApply, setShowAfterApply] = useState(false);
  const [respMsg, setRespMsg] = useState("");
  const [appObjFiles, setAppObjFiles] = useState(false);
  const [applicationObj, setApplicationObj] = useState(false);
  const [jobsUrl, setJobsUrl] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [actionType, setActionType] = useState("APPLY");
  const [formData, setFormData] = useState(null);
  const [showConfirmApply, setShowConfirmApply] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [allCountryList, setAllCountries] = useState(false);

  const getDisplayText = (section, sourceReference) => {
    let result = displayTextList.filter(
      (i) => i.section == section && i.sourceReference == sourceReference
    );
    if (result.length > 0) {
      return result[0].displayText;
    } else return "";
  };

  const statesAsProps = {
    jobDetails,
    setJobDetails,
    getDisplayText,
    countries,
    setCountries,
    phoneMinChar,
    setPhoneMinChar,
    statesOfCountry,
    setStateOfCountry,
    selectedCountryName,
    setSelectedCountryName,
    preferredContactMethodList,
    setPreferredContactMethodList,
    statesList,
    setStatesList,
    disabilityStatusList,
    setDisabilityStatusList,
    ethnicityList,
    setEthnicityList,
    raceList,
    setRaceList,
    genderList,
    setGenderList,
    veteranList,
    setVeteranList,
    zipRequirments,
    levelOfEduc,
    setLevelOfEduc,
    allCountryList,
    setAllCountries,
  };

  useEffect(() => {
    if (
      props.location.search.toLowerCase().includes("applicationid") &&
      Auth.candidateID !== ""
    ) {
      var appID = props.location.search.toLowerCase().split("=")[1];
      var formData = Auth;
      var formStr = JSON.stringify(formData);
      reqPostRetrieveCandidateApplication(formStr)
        .then((res) => {
          var appObj = res.data.filter((i) => i.applicationID == appID);
          if (appObj.length > 0) {
            setInitData(appObj[0]);
            setFieldValues(appObj[0]);
          } else {
            MsgBox({
              type: "error",
              message: "Error",
              description: "This Job application does not exist.",
            });

            return history.push({
              pathname: "/profile",
              search: "",
              state: null,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          GlobalApiErrorHandler({ errors: err.response.data.errors });
        });
    }
  }, [props.location.search, Auth]);

  useEffect(() => {
    reqGetJobUrl()
      .then((res) => {
        setJobsUrl(res.data.url);
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }, []);

  useEffect(() => {
    if (query.get("jobPostingID")) {
      setCurrentPath(
        currentPath + "?jobPostingID=" + query.get("jobPostingID")
      );
    }
    if (query.get("jobPostingID") && LookUpData && Auth && !AppliedJobs) {
      if (props.location.state === undefined) {
        getJobDetails();
      } else if (props.location.state) {
        if (
          props.location.state.jobDetails !== undefined &&
          props.location.state.jobDetails
        ) {
          setFieldValues(props.location.state.jobDetails);
        } else {
          getJobDetails();
        }
      }
      return;
    }

    if (query.get("jobPostingID") && LookUpData && Auth && AppliedJobs) {
      if (props.location.state === undefined) {
        getJobDetails();
      } else if (props.location.state) {
        if (
          props.location.state.jobDetails !== undefined &&
          props.location.state.jobDetails
        ) {
          setInitData(props.location.state.jobDetails);
          setFieldValues(props.location.state.jobDetails);
        } else {
          getJobDetails();
        }
      }
      return;
    }
  }, [query.get("jobPostingID"), LookUpData, Auth, AppliedJobs]);

  const getJobDetails = () => {
    if (applicationObj !== false) return;

    reqGetRetrieveJobDetails(query.get("jobPostingID"))
      .then((res) => {
        setInitData(res.data);
        setFieldValues(res.data);
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  };

  const setInitData = (data) => {
    setJobDetailsAfterFetch(data)
    if (data.applicationID > 0) {
      setApplicationObj(data);
    } else {
      reqGetAppProperties()
        .then((res) => {
          
          setApplicationObj(res.data);
        })
        .catch((err) => {
          console.log(err);
          GlobalApiErrorHandler({ errors: err.response.data.errors });
        });
    }

    var countryCode = data.jobPostingCountryCode ?? data.postingCountryCode;
    var countryID = LookUpData.countryList
      .filter((i) => i.countryCode == countryCode)
      .map((i) => i.countryID)[0];
    setJobDetails(data);
    setJobCountry({
      id: countryID,
      code: countryCode,
    });

    getLookupData(countryID);

    if (data.applicationID > 0) {
      setAppObjFiles({
        applicationID: data.applicationID,
        birthCertFileFriendlyName: data.applicantBirthCertFileFriendlyName,
        birthCertUniqueID: data.applicantBirthCertUniqueID,
        cXCFileFriendlyName: data.applicantCXCFileFriendlyName,
        cXCUniqueID: data.applicantCXCUniqueID,
        coverLetterFileFriendlyName: data.applicantCoverLetterFileFriendlyName,
        coverLetterUniqueID: data.applicantCoverLetterUniqueID,
        resumeFileFriendlyName: data.applicantResumeFileFriendlyName,
        resumeUniqueID: data.applicantResumeUniqueID,
        cOCFileFriendlyName: data.applicantCOCFileFriendlyName,
        cOCUniqueID: data.applicantCOCUniqueID,

        applicantNationalIDUniqueID: data.applicantNationalIDUniqueID,
        applicantNationalIDFileFriendlyName:
          data.applicantNationalIDFileFriendlyName,
        applicantHSDiplomaUniqueID: data.applicantHSDiplomaUniqueID,
        applicantHSDiplomaFileFriendlyName:
          data.applicantHSDiplomaFileFriendlyName,
        applicantPoliceRecordUniqueID: data.applicantPoliceRecordUniqueID,
        applicantPoliceRecordFileFriendlyName:
          data.applicantPoliceRecordFileFriendlyName,
      });
    } else {
      setAppObjFiles(false);
    }

    let AppliedJob = AppliedJobs?.filter(
      (i) => i.jobPostingID == query.get("jobPostingID")
    );
    if (AppliedJob && AppliedJob.length > 0) {
      MsgBox({
        type: "error",
        message: "",
        description: "You already applied for this job.",
      });
      return history.push("/profile");
    }
  };

  const setFieldValues = (job) => {
    formRef.setFieldsValue({
      candidateId: job.applicationID > 0 ? job.candidateID : Auth.candidateID,
      email: job.applicationID > 0 ? job.personalEmail : Auth.personalEmail,
      firstname: job.applicationID > 0 ? job.legalFirstName : Auth.firstName,
      lastname: job.applicationID > 0 ? job.legalLastName : Auth.lastName,
      middlename: job.applicationID > 0 ? job.middleName : Auth.middleName,
      phone: job.applicationID > 0 ? job.primaryPhone : Auth.primaryPhone,
      secondaryPhone:
        job.applicationID > 0 ? job.secondaryPhone : Auth.secondaryPhone,
      preferedContactMethod:
        job.applicationID > 0
          ? job.preferedContactMethodID
          : Auth.preferedContactMethodID,
      countryId: job.applicationID > 0 ? job.homeCountryID : Auth.countryID,
      addressLine1:
        job.applicationID > 0 ? job.homeAddress1 : Auth.homeAddress1,
      addressLine2:
        job.applicationID > 0 ? job.homeAddress2 : Auth.homeAddress2,
      addressLine3:
        job.applicationID > 0 ? job.homeAddress3 : Auth.homeAddress3,
      city: job.applicationID > 0 ? job.homeCity : Auth.city,
      state: job.applicationID > 0 ? job.homeStateID : Auth.stateID,
      postal: job.applicationID > 0 ? job.homeZipCode : Auth.zipCode,
      // Mailing address fields
      isPrimaryAddressSameAsMailing: job.applicationID > 0 ? job.isPrimaryAddressSameAsMailing : null,
      mailingAddress1: job.applicationID > 0 ? job.mailingAddress1 : null,
      mailingAddress2: job.applicationID > 0 ? job.mailingAddress2 : null,
      mailingAddress3: job.applicationID > 0 ? job.mailingAddress3 : null,
      mailingCity: job.applicationID > 0 ? job.mailingCity : null,
      mailingStateID: job.applicationID > 0 ? job.mailingStateID : null,
      mailingZipCode: job.applicationID > 0 ? job.mailingZipCode : null,
      //highestLevelOfEducationID: Auth.highestLevelOfEducationID,

      //Job Info
      JobReqID: job.jobReqID,
      applicationID: job.applicationID ?? 0,
      is18OrOlder: (job.is18OrOlder ?? "").toString(),
      workedAtiQorInd: (job.workedAtiQorInd ?? "").toString(),
      lastDayWorked:
        job.lastDayWorked === null || job.lastDayWorked === undefined
          ? ""
          : moment(job.lastDayWorked), //moment(job.lastDayWorked).format('YYYY-MM-DD')
      previousiQorLocation: job.previousiQorLocation,
      isSponsorshipRequired: (job.isSponsorshipRequired ?? "").toString(),
      highestLevelOfEducationID: (
        job.highestLevelOfEducationID ??
        Auth.highestLevelOfEducationID ??
        ""
      ).toString(),

      //Work Schedule
      availableWeekendInd: (job.availableWeekendInd ?? "").toString(),
      availableEveningInd: (job.availableEveningInd ?? "").toString(),
      scheduleRestrictionsInd: (job.scheduleRestrictionsInd ?? "").toString(),
      scheduleRestrictionsDetail: (
        job.scheduleRestrictionsDetail ?? ""
      ).toString(),

      //Employment Verification
      monthOfBirth:
        job.monthOfBirth === undefined || job.monthOfBirth === null
          ? ""
          : job.monthOfBirth > 0 && job.monthOfBirth < 10
          ? "0" + job.monthOfBirth
          : job.monthOfBirth,

      dayOfBirth:
        job.dayOfBirth === undefined || job.dayOfBirth === null
          ? ""
          : `${job.dayOfBirth}`.length < 2
          ? `0${job.dayOfBirth}`
          : `${job.dayOfBirth}`,

      //US props
      ethnicityID: job.ethnicityID,
      raceID: job.raceID,
      //genderID: (job.genderID ?? ''),
      gender: job.gender ?? "",
      veteranID: job.veteranID,
      disabilityID: job.disabilityID,
      californiaPrivacyNoticeAgreeInd: (
        job.californiaPrivacyNoticeAgreeInd ?? ""
      ).toString(),
      arbitrationAgreeInd: (job.arbitrationAgreeInd ?? "").toString(),
      ssnLastFourDigits: job.ssnLastFourDigits,

      //Applicant Statement
      applicantStatementAgreeInd:
        job.applicantStatementAgreeInd == null ||
        !job.applicantStatementAgreeInd
          ? ""
          : "true",
      applicantSignature: job.applicantSignature,
      
      // FEMA specific fields
      socialSecurityNumber: job.applicationID > 0 ? job.socialSecurityNumber : null,
      dateOfBirthFull: job.applicationID > 0 && job.dateOfBirthFull ? moment(job.dateOfBirthFull) : null,
      birthCity: job.applicationID > 0 ? job.birthCity : null,
      birthState: job.applicationID > 0 ? job.birthState : null,
      birthCountry: job.applicationID > 0 ? job.birthCountry : null,
      citizenshipCountry: job.applicationID > 0 ? job.citizenshipCountry : null,
    });
  };

  const resetFieldValues = (obj) => {
    formRef.setFieldsValue(obj);
  };

  const getLookupData = (countryID) => {
    if (displayTextList !== null) return;

    reqGetRetrieveApplicationLookupData(countryID)
      .then(function (response) {
        // var newdisplayTextList = {}
        // response.data.displayTextList.forEach(i => {
        //   newdisplayTextList[i.recordID] = i.displayText;
        // })
        setDisplayTextList(response.data.displayTextList);
        setCountries(response.data.countryList);
        setPreferredContactMethodList(response.data.preferredContactMethodList);
        setStatesList(response.data.statesList);

        setRaceList(response.data.raceList);
        setEthnicityList(response.data.ethnicityList);
        setDisabilityStatusList(response.data.disabilityStatusList);
        setGenderList(response.data.usGenderList);
        setVeteranList(response.data.veteranStatusList);
        setLevelOfEduc(response.data.levelOfEducationList);
        setAllCountries(response.data.allCountryList);

        try {
          var statesToShow = response.data.statesList.filter((state, i) => {
            return state.countryID === Auth.countryID;
          });
          setStateOfCountry(statesToShow);
          var currentCountrySelected = countries.filter((item, i) => {
            return item.countryID === Auth.countryID;
          });
          phoneFormatReq(currentCountrySelected[0].countryCode);
          handleZipPostalRequirments(currentCountrySelected[0].countryCode);
        } catch {
          //console.log("No states to show");
        }

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        GlobalApiErrorHandler({ errors: error.response.data.errors });
      });
  };

  const phoneFormatReq = (countryCode) => {
    switch (countryCode) {
      case "US":
      case "USA":
      case "PHL":
      case "IND":
      case "CAN":
      case "MEX":
      case "EGY":
        return setPhoneMinChar(10);
      case "COL":
        return setPhoneMinChar(10);
      case "PAN":
      case "HKG":
        return setPhoneMinChar(8);
      case "POL":
      case "AUS":
        return setPhoneMinChar(9);
      case "TTO":
        return setPhoneMinChar(7);
    }
  };

  const handleZipPostalRequirments = (countryCode) => {
    //console.log(countryCode);
    switch (countryCode) {
      case "US":
      case "USA":
      case "MEX":
        return setZipRequirements({
          accept: "digits",
          required: true,
          length: 5,
        });
      case "IND":
        return setZipRequirements({
          accept: "digits",
          required: true,
          length: 6,
        });

      case "PHL":
      case "AUS":
        return setZipRequirements({
          accept: "digits",
          required: true,
          length: 4,
        });
      case "POL":
        return setZipRequirements({
          accept: "digits",
          required: true,
          length: 5,
        });
      case "CAN":
        return setZipRequirements({
          accept: "letters",
          required: true,
          length: 6,
        });
      case "COL":
        return setZipRequirements({
          accept: "digits",
          required: false,
          length: 6,
        });
      case "PAN":
      case "TTO":
      case "HKG":
        return setZipRequirements({
          accept: "letters",
          required: false,
        });
      case "EGY":
        return setZipRequirements({
          accept: "digits",
          required: false,
          length: 7,
        });
    }
  };

  const format_bool = (value) => {
    switch (value) {
      case "true":
        return true;
      case "false":
        return false;
      case "":
        return null;
    }
  };

  const validateMessages = {
    required: "${label} is required.",
  };

  const isTTO = () => {
    if (
      jobDetails &&
      (jobDetails.jobPostingCountryCode === "TTO" ||
        jobDetails.postingCountryCode === "TTO")
    )
      return true;
    else return false;
  };

  const isPAN = () => {
    if (
      jobDetails &&
      (jobDetails.jobPostingCountryCode === "PAN" ||
        jobDetails.postingCountryCode === "PAN")
    )
      return true;
    else return false;
  };

  const isDLCatCode = () => {
    if (jobDetails) {
      if (["DL", "DLA"].includes(jobDetails.laborCategoryCode)) {
        return true;
      } else {
        return false;
      }
    }
  };

  const resetStates = () => {
    setFormData(null);
    setShowConfirmApply(false);
    setShowConfirmDelete(false);
  };

  const formSubmit = (form) => {
    setLoading(true);
    
    
    var jsonData = {
      applicationID: string_trim(form.applicationID),
      candidateID: string_trim(Auth.candidateID),
      legalFirstName: string_trim(form.firstname),
      middleName: string_trim(form.middlename),
      legalLastName: string_trim(form.lastname),
      personalEmail: string_trim(form.email),
      homeAddress1: string_trim(form.addressLine1),
      homeAddress2: string_trim(form.addressLine2),
      homeAddress3: string_trim(form.addressLine3),
      homeCity: string_trim(form.city),
      homeStateID: parseInt(form.state),
      homeZipCode: string_trim(
        form.postal == null ? null : form.postal.toString()
      ),
      homeCountryID: parseInt(form.countryId),
      // Mailing address fields
      isPrimaryAddressSameAsMailing: form.isPrimaryAddressSameAsMailing,
      mailingAddress1: string_trim(form.mailingAddress1),
      mailingAddress2: string_trim(form.mailingAddress2),
      mailingAddress3: string_trim(form.mailingAddress3),
      mailingCity: string_trim(form.mailingCity),
      mailingStateID: form.mailingStateID ? parseInt(form.mailingStateID) : null,
      mailingZipCode: string_trim(
        form.mailingZipCode == null ? null : form.mailingZipCode.toString()
      ),
      primaryPhone: string_trim(form.phone),
      secondaryPhone: string_trim(form.secondaryPhone),
      preferedContactMethodID: string_trim(form.preferedContactMethod),

      //Document Component

      applicantResumeUniqueID: !appObjFiles
        ? Auth.candidateResumeUniqueID
        : appObjFiles.resumeUniqueID,
      applicantResumeFileFriendlyName: !appObjFiles
        ? Auth.candidateResumeFileFriendlyName
        : appObjFiles.resumeFileFriendlyName,
      applicantCoverLetterUniqueID: !appObjFiles
        ? Auth.candidateCoverLetterUniqueID
        : appObjFiles.coverLetterUniqueID,
      applicantCoverLetterFileFriendlyName: !appObjFiles
        ? Auth.candidateCoverLetterFileFriendlyName
        : appObjFiles.coverLetterFileFriendlyName,
      applicantBirthCertUniqueID: !appObjFiles
        ? Auth.candidateBirthCertificateUniqueID
        : appObjFiles.birthCertUniqueID,
      applicantBirthCertFileFriendlyName: !appObjFiles
        ? Auth.candidateBirtCertificateFriendlyName
        : appObjFiles.birthCertFileFriendlyName,
      applicantCXCUniqueID: !appObjFiles
        ? Auth.candidateCXCUniqueID
        : appObjFiles.cXCUniqueID,
      applicantCXCFileFriendlyName: !appObjFiles
        ? Auth.candidateCXCFriendlyName
        : appObjFiles.cXCFileFriendlyName,
      applicantCOCUniqueID: !appObjFiles
        ? Auth.candidateCOCUniqueID
        : appObjFiles.cOCUniqueID,
      applicantCOCFileFriendlyName: !appObjFiles
        ? Auth.candidateCOCFileFriendlyName
        : appObjFiles.cOCFileFriendlyName,
      applicantNationalIDFileFriendlyName: !appObjFiles
        ? Auth.candidateNationalIDFileFriendlyName
        : appObjFiles.applicantNationalIDFileFriendlyName,
      applicantNationalIDUniqueID: !appObjFiles
        ? Auth.candidateNationalIDUniqueID
        : appObjFiles.applicantNationalIDUniqueID,
      applicantHSDiplomaFileFriendlyName: !appObjFiles
        ? Auth.candidateHSDiplomaFileFriendlyName
        : appObjFiles.applicantHSDiplomaFileFriendlyName,
      applicantHSDiplomaUniqueID: !appObjFiles
        ? Auth.candidateHSDiplomaUniqueID
        : appObjFiles.applicantHSDiplomaUniqueID,
      applicantPoliceRecordFileFriendlyName: !appObjFiles
        ? Auth.candidatePoliceRecordFileFriendlyName
        : appObjFiles.applicantPoliceRecordFileFriendlyName,
      applicantPoliceRecordUniqueID: !appObjFiles
        ? Auth.candidatePoliceRecordUniqueID
        : appObjFiles.applicantPoliceRecordUniqueID,

      //JobInfo
      jobReqID: parseInt(jobDetails.jobReqID),
      jobPostingID: parseInt(jobDetails.jobPostingID),
      postingJobTitle:
        jobDetails.applicationID > 0
          ? jobDetails.postingJobTitle
          : jobDetails.jobTitleName,
      postingCity:
        jobDetails.applicationID > 0
          ? jobDetails.postingCity
          : jobDetails.jobPostingCity,
      postingState:
        jobDetails.applicationID > 0
          ? jobDetails.postingState
          : jobDetails.jobPostingStateName,
      postingCountryCode:
        jobDetails.applicationID > 0
          ? jobDetails.postingCountryCode
          : jobDetails.jobPostingCountryCode,
      postingCountryName:
        jobDetails.applicationID > 0
          ? jobDetails.postingCountryName
          : jobDetails.jobPostingCountryName,

      //Job Info

      is18OrOlder: format_bool(form.is18OrOlder),
      workedAtiQorInd: format_bool(form.workedAtiQorInd),
      lastDayWorked: form.lastDayWorked == "" ? null : form.lastDayWorked,
      previousiQorLocation: form.previousiQorLocation,
      isSponsorshipRequired: format_bool(form.isSponsorshipRequired),
      highestLevelOfEducationID:
        form.highestLevelOfEducationID !== null
          ? parseInt(form.highestLevelOfEducationID)
          : null,

      //Work Schedule
      availableWeekendInd: format_bool(form.availableWeekendInd ?? ""),
      availableEveningInd: format_bool(form.availableEveningInd ?? ""),
      scheduleRestrictionsInd: format_bool(form.scheduleRestrictionsInd ?? ""),
      scheduleRestrictionsDetail: form.scheduleRestrictionsDetail ?? null,
      //Employment Verification
      monthOfBirth:
        form.monthOfBirth === undefined || form.monthOfBirth === null
          ? null
          : parseInt(
              form.monthOfBirth < 10
                ? "0" + form.monthOfBirth
                : form.monthOfBirth
            ),

      dayOfBirth:
        form.dayOfBirth === undefined ||
        form.dayOfBirth === null ||
        form.dayOfBirth === ""
          ? null
          : parseInt(form.dayOfBirth),

      //US props
      ethnicityID: form.ethnicityID,
      raceID: form.raceID,
      //genderID: (form.genderID === '' ? null : form.genderID),
      gender: form.gender,
      veteranID: form.veteranID,
      disabilityID: form.disabilityID === "" ? null : form.disabilityID,
      californiaPrivacyNoticeAgreeInd: format_bool(
        form.californiaPrivacyNoticeAgreeInd
      ),
      arbitrationAgreeInd: format_bool(form.arbitrationAgreeInd),
      ssnLastFourDigits: form.ssnLastFourDigits,
      
      // FEMA specific fields
      socialSecurityNumber: form.socialSecurityNumber,
      dateOfBirthFull: form.dateOfBirthFull ? moment(form.dateOfBirthFull).format('YYYY-MM-DD') : null,
      birthCity: form.birthCity,
      birthState: form.birthState,
      birthCountry: form.birthCountry,
      citizenshipCountry: form.citizenshipCountry,
      
      //Applicant Statement
      applicantStatementAgreeInd: format_bool(form.applicantStatementAgreeInd),
      applicantSignature: form.applicantSignature,
      action: actionType,
    };

    var finalPayload = { ...applicationObj, ...jsonData };
    var jsonStr = JSON.stringify(finalPayload);

    

    // return;
    reqPostSaveApplication(jsonStr)
      .then((res) => {
        if (res.data.isSuccess) {
          setApplicationObj({ ...applicationObj, ...jsonData });
          if (actionType === "SAVE") {
            setRespMsg("Your application has been saved");
            MsgBox({
              type: "success",
              message: "",
              description: "Your application has been saved",
            });
          } else if (actionType === "APPLY") {
            setRespMsg("Your application has been submitted");
            MsgBox({
              type: "success",
              message: "",
              description: "Your application has been submitted",
            });
          } else if (actionType === "DELETE") {
            setRespMsg("Your application has been deleted");
            MsgBox({
              type: "success",
              message: "",
              description: "Your application has been deleted",
            });
          }

          setShowAfterApply(true);
        } else {
          MsgBox({
            type: "error",
            message: "Error",
            description: res.data.errorMessage,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      })
      .finally(() => {
        setLoading(false);
        resetStates();
      });
  };

  const onFormValidate = (values) => {
    setFormData(values);
    if (actionType == "APPLY") {
      setShowConfirmApply(true);
    } else if (actionType === "SAVE") {
      formSubmit(values);
    } else if (actionType === "DELETE") {
      setShowConfirmDelete(true);
    }
  };

  const onFormValidateFailed = (errorInfo) => {
    if (actionType === "SAVE") {
      formSubmit(errorInfo.values);
    } else {
      console.error("Failed:", errorInfo);
      setLoading(false);
      formRef.scrollToField(errorInfo.errorFields[0].name);
    }
  };

  const handleSave = () => {
    setActionType("SAVE");
    formRef.submit();
  };

  return !showAfterApply ? (
    <>
      <CustomAlertModal
        type="confirm"
        content="Are you sure you want to apply to this job?"
        onCancel={() => {
          resetStates();
        }}
        visible={showConfirmApply}
        destroyOnClose={true}
        footer={[
          <Button
            key="yes"
            onClick={(e) => {
              e.preventDefault();
              setShowConfirmApply(false);
              formSubmit(formData);
            }}
            type="danger"
          >
            Yes
          </Button>,
          <Button key="no" onClick={(e) => resetStates()} type="danger">
            No
          </Button>,
        ]}
      />
      <CustomAlertModal
        type="confirm"
        content="Are you sure you want to delete your application?"
        onCancel={() => {
          resetStates();
        }}
        visible={showConfirmDelete}
        destroyOnClose={true}
        footer={[
          <Button
            key="yes"
            onClick={(e) => {
              e.preventDefault();
              setShowConfirmDelete(false);
              formSubmit(formData);
            }}
            type="danger"
          >
            Yes
          </Button>,
          <Button key="no" onClick={(e) => resetStates()} type="danger">
            No
          </Button>,
        ]}
      />
      <Row>
        <Col md={{ span: 4 }}></Col>
        <Col md={{ span: 11 }} style={{ marginLeft: "20px", fontSize: "32px" }}>
          <div>
            {jobDetails
              ? jobDetails.jobTitleName ?? jobDetails.reqJobTitleName
              : ""}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={4} sm={24}>
          <BrowserView>
            <ScrollSpy
              countrycode={jobCountry ? jobCountry.code : ""}
              isLoading={isLoading}
              workSchedShow={
                jobDetails &&
                ["DL", "DLA"].includes(jobDetails.laborCategoryCode)
                  ? true
                  : false
              }
            />
          </BrowserView>
        </Col>
        <Col md={20} sm={24}>
          <Form
            {...layout}
            name="profile"
            initialValues={{
              remember: true,
            }}
            className="label-left-align"
            layout="vertical"
            onFinish={onFormValidate}
            onFinishFailed={onFormValidateFailed}
            validateMessages={validateMessages}
            form={formRef}
          >
            <Form.Item
              label="applicationID"
              name="applicationID"
              initialValue={0}
              hidden={true}
            >
              <Input disabled />
            </Form.Item>
            <div className="scrollspy-container">
              <section id="personal-info">
              {jobDetails &&
                  (jobDetails.profitCenterName === "FEMA" ||
                  jobDetails.reqProfitCenterName === "FEMA") ? (
                  <PersonalInformationFEMA
                    {...statesAsProps}
                    form={formRef}
                    phoneFormatReq={phoneFormatReq}
                    hideIds={true}
                    isProfileLoading={isLoading}
                    handleZipPostalRequirments={handleZipPostalRequirments}
                    showEducLvl={false}
                  />
                ) : (
                    <PersonalInformation
                      {...statesAsProps}
                      form={formRef}
                      phoneFormatReq={phoneFormatReq}
                      hideIds={true}
                      isProfileLoading={isLoading}
                      handleZipPostalRequirments={handleZipPostalRequirments}
                      showEducLvl={false}
                    />
                )}
                
              </section>
              {jobDetails?.homeCountryCode === 'PAN' || jobDetails?.homeCountryCode === 'TTO' || jobDetails?.jobPostingCountryCode === 'PAN' || jobDetails?.jobPostingCountryCode === 'TTO' ?
                ('')
                :
                (<section id="documents">
                  <DocumentUpload
                    showTTOfiles={isTTO()}
                    showPANfiles={isPAN()}
                    isProfileLoading={isLoading}
                    resumeRequired={!isDLCatCode()}
                    {...{ appObjFiles, setAppObjFiles }}
                  />
                </section>)
              }
              
              <JobInfo
                {...statesAsProps}
                form={formRef}
                isLoading={isLoading}
                resetFieldValues={resetFieldValues}
                workSchedShow={isDLCatCode()}
              />
            </div>
            <Row
              style={{
                paddingTop: "1em",
                paddingBottom: "2em",
                paddingLeft: "10px",
              }}
            >
              <Col md={24} xs={24}>
                <Card>
                  <div className="button-holder">
                    {jobDetails && jobDetails.applicationID > 0 ? (
                      <Button
                        loading={isLoading}
                        type="danger"
                        onClick={() => {
                          setActionType("DELETE");
                          formRef.submit();
                        }}
                      >
                        Delete Application
                      </Button>
                    ) : (
                      <></>
                    )}
                    <Button
                      type="danger"
                      loading={isLoading}
                      onClick={handleSave}
                    >
                      Save as Draft
                    </Button>
                    <Button
                      type="danger"
                      loading={isLoading}
                      onClick={() => {
                        setActionType("APPLY");
                        formRef.submit();
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  ) : (
    <Card size="large" title="Thank you for applying" className="iqor-header">
      <br />
      <br />
      <Row justify="space-between">
        <Col md={{ span: 24 }}>
          <h5>{respMsg}</h5>
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col md={{ span: 24 }} xs={{ span: 24 }}>
          <Button
            type="danger"
            disabled={jobsUrl === ""}
            className="expand-on-mobile"
            htmlType="button"
            onClick={() => {
              //history.push("/jobs")
              window.location.href = jobsUrl;
            }}
          >
            Back to Job Listings
          </Button>{" "}
          <Button
            type="danger"
            className="expand-on-mobile"
            htmlType="button"
            onClick={() => {
              history.push("/profile");
            }}
          >
            View Profile
          </Button>
        </Col>
      </Row>
    </Card>
  );
};
